import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/valb2-logo.png'
import _imports_1 from '../assets/image/logo.png'
import _imports_2 from '../assets/image/avatar.png'
import _imports_3 from '../assets/image/Zh.png'
import _imports_4 from '../assets/image/En.png'


const _withScopeId = n => (_pushScopeId("data-v-59f2126c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside-name" }
const _hoisted_2 = {
  key: 0,
  class: "imagess",
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  class: "images",
  src: _imports_1
}
const _hoisted_4 = { class: "user-panel hidden-xs" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pull-left image" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "addtabsit" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      class: "img-circle"
    })
  ])
], -1))
const _hoisted_6 = {
  key: 0,
  class: "pull-left info"
}
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "header-lf" }
const _hoisted_9 = { class: "language" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trigger-min" }, null, -1))
const _hoisted_11 = { class: "header-fhs" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login-icon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "logo flx-center" }
const _hoisted_14 = { class: "logo-name" }
const _hoisted_15 = { class: "content-box" }

import { reactive, onMounted, ref, watch, defineComponent } from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import { ArrowRight, ArrowLeft } from "@element-plus/icons-vue";
import screenfull from "screenfull";
import { Sunny, Moon } from "@element-plus/icons-vue";
import { useDark } from "@vueuse/core";
import api from "@/request/api";
import En from "@/components/En.vue";
import { useI18n } from "vue-i18n";
import { generateTitle } from "@/utils/i18n";
import i18n from "@/lang/index";
import enLocale from "@/lang/en";
import zhLocale from "@/lang/zh";
import elementEnLocale from "element-plus/lib/locale/lang/en";
import elementZhLocale from "element-plus/lib/locale/lang/zh-cn";
import watermark from "../utils/watermark";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  props: ["menuList"],
  setup(__props) {



const { locale } = useI18n();

const isCollapse = ref(false);

const router = useRouter();
let nickname: any = sessionStorage.getItem("nickname");
/// 水印
watermark.set(nickname);
const menuList = router.getRoutes().filter((v) => v.meta.isShow);
const logout = () => {
  let username: any = {
    username: sessionStorage.getItem("username"),
  };
  api.post("user/logout", username).then((res: any) => {
    // 清除 Token
    sessionStorage.clear();
    // 重定向到登陆页
    router.replace("/login");
    ElMessage.success("退出登录成功！");
    router.go(0);
  });
};

const fullscreenElement = ref(null); // 用于保存全屏显示的元素
// 切换全屏状态的方法
const toggleFullscreen = () => {
  if (screenfull.isEnabled) {
    const elem = fullscreenElement.value as unknown as Element;
    screenfull.toggle(elem);
  } else {
  }
};
// 2. 使用useDark
const isDark = useDark();
// 3. 主题配置
const themeConfig = reactive({
  isDark: isDark,
});

const changebgcolor = (value: any) => {
  // true 暗色  false 白色
  if (value) {
    sessionStorage.setItem("bgcolor", "white");
  } else {
    sessionStorage.setItem("bgcolor", "black");
  }
};

// 语言切换
let languageShow = ref(sessionStorage.getItem("langShow") || "2");
const changeLg = () => {
  languageShow.value = "2";
  locale.value = "enLocale";
  sessionStorage.setItem("lang", locale.value);
  sessionStorage.setItem("langShow", languageShow.value);

  router.go(0);
};
const changeLgS = () => {
  languageShow.value = "1";
  locale.value = "zhLocale";
  sessionStorage.setItem("lang", locale.value);
  sessionStorage.setItem("langShow", languageShow.value);
  router.go(0);
};

return (_ctx: any,_cache: any) => {
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: "common-layout",
    ref_key: "fullscreenElement",
    ref: fullscreenElement
  }, [
    _createVNode(_unref(watermark), { text: _unref(nickname) }, null, 8, ["text"]),
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          class: _normalizeClass({ collapsed: isCollapse.value }),
          style: _normalizeStyle(themeConfig.isDark ? '' : 'background-color: #fff;')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "logo",
                style: _normalizeStyle(isCollapse.value === false ? 'padding: 8px;' : 'padding: 4px;')
              }, [
                (isCollapse.value === true)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                  : (_openBlock(), _createElementBlock("img", _hoisted_3))
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (isCollapse.value === false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(nickname)), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_SuccessFilled)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("login.online")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_menu, {
              "active-text-color": "#409eff",
              class: "el-menu-vertical-demo",
              router: "",
              collapse: isCollapse.value,
              "collapse-transition": false,
              "default-active": _ctx.$route.path
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (subItem) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: subItem.path
                  }, [
                    (subItem.children?.length)
                      ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                          index: subItem.path,
                          key: subItem.path,
                          class: _normalizeClass({ collapsed: isCollapse.value })
                        }, {
                          title: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(subItem.meta.icon)))
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(En, {
                              title: _unref(generateTitle)(subItem.meta.title)
                            }, null, 8, ["title"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItem.children, (item) => {
                              return (_openBlock(), _createBlock(_component_el_menu_item, {
                                key: item.path,
                                index: item.path,
                                class: _normalizeClass({ collapsed: isCollapse.value })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(En, {
                                    title: _unref(generateTitle)(item.meta.title)
                                  }, null, 8, ["title"])
                                ]),
                                _: 2
                              }, 1032, ["index", "class"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["index", "class"]))
                      : (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 1,
                          class: _normalizeClass({ collapsed: isCollapse.value }),
                          index: subItem.path
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(subItem.meta.icon)))
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(En, {
                              title: _unref(generateTitle)(subItem.meta.title)
                            }, null, 8, ["title"])
                          ]),
                          _: 2
                        }, 1032, ["class", "index"]))
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["collapse", "default-active"])
          ]),
          _: 1
        }, 8, ["class", "style"]),
        _createVNode(_component_el_container, { class: "app" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "heds",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isCollapse.value = !isCollapse.value))
                }, [
                  (isCollapse.value)
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Expand)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Fold)
                        ]),
                        _: 1
                      }))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("img", {
                      src: _imports_3,
                      onClick: changeLg
                    }, null, 512), [
                      [_vShow, _unref(languageShow) === '1']
                    ]),
                    _withDirectives(_createElementVNode("img", {
                      src: _imports_4,
                      onClick: changeLgS
                    }, null, 512), [
                      [_vShow, _unref(languageShow) === '2']
                    ])
                  ]),
                  _hoisted_10,
                  _createVNode(_component_el_popover, {
                    ref: "popoverRef",
                    trigger: "click"
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(nickname)), 1)
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "dasd",
                        onClick: logout
                      }, [
                        _createVNode(_component_el_icon, { class: "icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SwitchButton)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("routers.logOut")), 1)
                      ])
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 512))
}
}

})